import { render } from "./CleanupType.vue?vue&type=template&id=18f0bb6a"
import script from "./CleanupType.vue?vue&type=script&lang=js"
export * from "./CleanupType.vue?vue&type=script&lang=js"
script.render = render

export default script